import React from 'react'
import PropTypes from 'prop-types'
import { DELIVERY_METHOD } from 'domains/seller-inbound/constants'
import StatusBadge from 'components/atoms/status-badge'


const propTypes = {
  delivery_method: PropTypes.string
}

const SellerInboundDeliveryMethodBadge = ({ delivery_method }) => {

  const colorMap = {
    [DELIVERY_METHOD.PICKUP]  : 'primary',
    [DELIVERY_METHOD.DROPOFF] : 'info'
  }

  const color = colorMap[delivery_method] || 'default'

  return <StatusBadge color={ color } label={ delivery_method } />
}

SellerInboundDeliveryMethodBadge.propTypes = propTypes

export default SellerInboundDeliveryMethodBadge